import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function JobDetails() {
  const navigate = useNavigate();
  const [isApplied, setIsApplied] = useState(false);

  const job = {
    id: 1,
    title: 'مضيف استقبال - معرض الرياض الدولي للتقنية',
    company: 'شركة المعارض السعودية',
    location: 'مركز الرياض الدولي للمؤتمرات',
    startDate: '2024-02-15',
    endDate: '2024-02-18',
    dailyRate: '150',
    totalDays: 4,
    workingHours: '8 ساعات يومياً',
    image: 'https://public.readdy.ai/ai/img_res/47c11e7b5b1f1e83ccd605735ad0e771.jpg',
    description: 'نبحث عن مضيفين محترفين للعمل في معرض الرياض الدولي للتقنية. ستكون مسؤولاً عن استقبال الزوار وتوجيههم وتقديم المساعدة اللازمة.',
    requirements: [
      'خبرة سابقة في مجال الضيافة أو خدمة العملاء',
      'مهارات تواصل ممتازة باللغتين العربية والإنجليزية',
      'مظهر لائق ومهني',
      'القدرة على الوقوف لفترات طويلة',
      'مرونة في التعامل مع الجمهور'
    ],
    responsibilities: [
      'استقبال وترحيب الزوار',
      'توجيه الزوار إلى الأجنحة المختلفة',
      'الإجابة على استفسارات الزوار',
      'المساعدة في تنظيم الفعاليات',
      'التأكد من سير العمل بسلاسة'
    ],
    benefits: [
      'راتب يومي مجزي',
      'وجبات مجانية',
      'مواصلات مجانية',
      'شهادة خبرة',
      'فرصة للتطوير المهني'
    ],
    applicants: 23,
    deadline: '2024-02-10'
  };

  const handleApply = () => {
    setIsApplied(true);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="تفاصيل الوظيفة"
        leftAction={
          <button 
            onClick={() => navigate('/jobs')}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        }
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-share-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-24 px-4">
        {/* Job Image */}
        <div className="relative h-48 rounded-lg overflow-hidden mb-6 mt-4">
          <img 
            src={job.image} 
            alt={job.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute bottom-4 left-4 right-4">
            <h1 className="text-white text-xl font-bold mb-2">{job.title}</h1>
            <p className="text-white/90 text-sm">{job.company}</p>
          </div>
        </div>

        {/* Job Summary */}
        <Card className="mb-6">
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center">
              <div className="w-12 h-12 bg-[#4CAF50]/10 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-money-dollar-circle-line text-[#4CAF50] text-xl"></i>
              </div>
              <p className="text-lg font-bold text-[#333333]">{job.dailyRate} ريال</p>
              <p className="text-[#757575] text-xs">يومياً</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-[#1565C0]/10 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-calendar-line text-[#1565C0] text-xl"></i>
              </div>
              <p className="text-lg font-bold text-[#333333]">{job.totalDays} أيام</p>
              <p className="text-[#757575] text-xs">مدة العمل</p>
            </div>
          </div>
        </Card>

        {/* Job Info */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">معلومات الوظيفة</h3>
          <div className="space-y-3">
            <div className="flex items-center">
              <i className="ri-map-pin-line text-[#607D8B] ml-3"></i>
              <div>
                <p className="text-[#757575] text-sm">الموقع</p>
                <p className="font-medium text-[#333333]">{job.location}</p>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-calendar-line text-[#607D8B] ml-3"></i>
              <div>
                <p className="text-[#757575] text-sm">تاريخ البداية</p>
                <p className="font-medium text-[#333333]">{formatDate(job.startDate)}</p>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-calendar-check-line text-[#607D8B] ml-3"></i>
              <div>
                <p className="text-[#757575] text-sm">تاريخ النهاية</p>
                <p className="font-medium text-[#333333]">{formatDate(job.endDate)}</p>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line text-[#607D8B] ml-3"></i>
              <div>
                <p className="text-[#757575] text-sm">ساعات العمل</p>
                <p className="font-medium text-[#333333]">{job.workingHours}</p>
              </div>
            </div>
          </div>
        </Card>

        {/* Description */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">وصف الوظيفة</h3>
          <p className="text-[#757575] leading-relaxed">{job.description}</p>
        </Card>

        {/* Requirements */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">المتطلبات</h3>
          <ul className="space-y-2">
            {job.requirements.map((requirement, index) => (
              <li key={index} className="flex items-start">
                <i className="ri-check-line text-[#4CAF50] ml-2 mt-1 flex-shrink-0"></i>
                <span className="text-[#757575] text-sm">{requirement}</span>
              </li>
            ))}
          </ul>
        </Card>

        {/* Responsibilities */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">المسؤوليات</h3>
          <ul className="space-y-2">
            {job.responsibilities.map((responsibility, index) => (
              <li key={index} className="flex items-start">
                <i className="ri-arrow-left-s-line text-[#1565C0] ml-2 mt-1 flex-shrink-0"></i>
                <span className="text-[#757575] text-sm">{responsibility}</span>
              </li>
            ))}
          </ul>
        </Card>

        {/* Benefits */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">المزايا</h3>
          <ul className="space-y-2">
            {job.benefits.map((benefit, index) => (
              <li key={index} className="flex items-start">
                <i className="ri-gift-line text-[#FBC02D] ml-2 mt-1 flex-shrink-0"></i>
                <span className="text-[#757575] text-sm">{benefit}</span>
              </li>
            ))}
          </ul>
        </Card>

        {/* Application Stats */}
        <Card className="mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-[#333333]">إحصائيات التقديم</h3>
              <p className="text-[#757575] text-sm">{job.applicants} متقدم حتى الآن</p>
            </div>
            <div className="text-right">
              <p className="text-[#757575] text-sm">آخر موعد للتقديم</p>
              <p className="font-semibold text-[#333333]">{formatDate(job.deadline)}</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Fixed Bottom Action */}
      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-gray-200 p-4">
        <div className="flex gap-3">
          <button className="w-12 h-12 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-gray-50">
            <i className="ri-heart-line text-[#607D8B]"></i>
          </button>
          <Button 
            variant={isApplied ? "secondary" : "primary"} 
            className="flex-1"
            onClick={handleApply}
            disabled={isApplied}
          >
            {isApplied ? (
              <>
                <i className="ri-check-line ml-2"></i>
                تم التقديم
              </>
            ) : (
              'تقدم الآن'
            )}
          </Button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}